interface DownloadContentResponse {
  fileData?: string
  filename?: string
  contentType?: string
}

export const openDownloadedContent = (response: DownloadContentResponse) => {
  if (!response?.fileData || !response?.filename) return;

  const byteCharacters = atob(response.fileData);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: response.contentType });
  const url = window.URL.createObjectURL(blob);
  window.open(url, '_blank');
};
